export default __webpack_public_path__ + "static/media/hht2_ep7_speaking_03.42ac1ce2.png";